import { getRegisterFunction } from '../../utils/register.js';
import { OneUxCheckboxElement } from './OneUxCheckboxElement.js';
export const register = getRegisterFunction(OneUxCheckboxElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-checkbox': OneUxCheckboxElement;
    "checkbox-0fdcc7e16ee93cc05b4f12e795d0fd0a": OneUxCheckboxElement;
  }
}